import { JetpacSimOpsApi } from 'api'
import { AxiosPromise } from 'axios'
import OrbitSession from 'hooks/useCookies'
import {
  GetRefundsResponse,
  GetUserOrderPaymentsResponse,
  RefundHistoryResponse,
  RefundRequest,
  RefundResponse
} from 'types/api/ops/v2/finance.type'

const getAuthHeaders = () => {
  const faberToken = OrbitSession.get('faberToken')
  return { Authorization: `Bearer ${faberToken}` }
}

class FinanceAPI {
  static getUserOrders({
    userId,
    limit = 10,
    offset = 0,
    sort = 'desc',
    status,
    paymentStatus
  }: {
    userId: string
    limit?: number
    offset?: number
    sort?: string
    status?: string
    paymentStatus?: string
  }): AxiosPromise<GetUserOrderPaymentsResponse> {
    const params = new URLSearchParams({
      limit: String(limit),
      offset: String(offset),
      sort
    })

    if (status) params.append('status', status)
    if (paymentStatus) params.append('payment_status', paymentStatus)

    return JetpacSimOpsApi.httpGet(
      `/finance/user/${userId}/orders?${params.toString()}`,
      getAuthHeaders()
    )
  }

  static submitRefund(body: RefundRequest): AxiosPromise<RefundResponse> {
    return JetpacSimOpsApi.httpPost('/finance/refund', getAuthHeaders(), body)
  }

  static getOrderRefunds(orderID: string): AxiosPromise<GetRefundsResponse> {
    return JetpacSimOpsApi.httpGet(
      `/finance/refund/${orderID}`,
      getAuthHeaders()
    )
  }

  static getRefundHistory({
    userId,
    limit = 10,
    offset = 0,
    status
  }: {
    userId?: string
    limit?: number
    offset?: number
    status?: string
  }): AxiosPromise<RefundHistoryResponse> {
    const params = new URLSearchParams({
      limit: String(limit),
      offset: String(offset)
    })

    if (userId) params.append('user_id', userId)
    if (status) params.append('status', status)

    return JetpacSimOpsApi.httpGet(
      `/finance/refunds?${params.toString()}`,
      getAuthHeaders()
    )
  }
}

export default FinanceAPI
